import LegalLayout from "./LegalLayout";

export default function TermsPage() {
  return (
    <LegalLayout title="Terms & Conditions">
      <p>
        Welcome to VEE Consultancy. By accessing this website or registering for our free live Masterclass / Webinar, you agree to be bound by the following Terms & Conditions. Please read them carefully.
      </p>

      <h2 className="text-2xl font-bold mt-10 mb-3">1. Nature of Content</h2>
      <p>
        All content, sessions, and materials provided by VEE Consultancy — including the live Masterclass — are offered for <strong>educational and informational purposes only</strong>. They focus on market structure, analysis frameworks, and trading concepts intended to help participants study market behaviour.
      </p>

      <h2 className="text-2xl font-bold mt-10 mb-3">2. No Investment Advice</h2>
      <p>
        Nothing on this website or in our webinars constitutes <strong>investment advice, trading recommendations, or a solicitation</strong> to buy or sell any financial instrument. VEE Consultancy is <strong>not a SEBI-registered investment advisor or research analyst</strong>.
      </p>

      <h2 className="text-2xl font-bold mt-10 mb-3">3. User Responsibility</h2>
      <p>
        By attending the Masterclass, you acknowledge that:
      </p>
      <ul className="list-disc pl-6 space-y-2">
        <li>Trading in financial markets involves significant risk of loss.</li>
        <li>Past performance and illustrative examples are not indicative of future results.</li>
        <li>Any application of ideas, frameworks, or concepts is done at your sole discretion and risk.</li>
        <li>You will consult a qualified financial professional before making any financial decisions.</li>
      </ul>

      <h2 className="text-2xl font-bold mt-10 mb-3">4. Registration & Communication</h2>
      <p>
        When you register, you consent to receiving webinar-related communication via WhatsApp, SMS, email, or phone — including confirmations, reminders, and occasional educational updates. You may opt out at any time by replying <em>STOP</em> on WhatsApp or unsubscribing from emails.
      </p>

      <h2 className="text-2xl font-bold mt-10 mb-3">5. Intellectual Property</h2>
      <p>
        All content, trademarks, logos, and materials displayed on this website and during the webinar are the property of VEE Consultancy. You may not reproduce, distribute, or repurpose them without prior written consent.
      </p>

      <h2 className="text-2xl font-bold mt-10 mb-3">6. Third-Party Disclaimers</h2>
      <p>
        This website is <strong>not affiliated with, endorsed by, or sponsored by Meta (Facebook / Instagram) or Google</strong>. These names are trademarks of their respective owners.
      </p>

      <h2 className="text-2xl font-bold mt-10 mb-3">7. Changes to Terms</h2>
      <p>
        VEE Consultancy reserves the right to update these Terms at any time. Continued use of the website after changes constitutes acceptance of the revised Terms.
      </p>

      <h2 className="text-2xl font-bold mt-10 mb-3">8. Governing Law</h2>
      <p>
        These Terms are governed by the laws of India. Any disputes will be subject to the exclusive jurisdiction of the courts in [Your City], India.
      </p>
    </LegalLayout>
  );
}
